import styled from 'styled-components/macro'

export const WarningTitle = styled.span`
    color: #ff5722; 
`;
